import { EquipmentDmgFilterType } from '@/entities/equipment';
import { TRepairCostingSchema } from '@/schemas/repair-costing/repair-costing.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapDmgFilterAPI } from '@/utils/map.utils';
import { FindAllRepairServicesByEquipmentDamage } from '../entities/repair-costing';

const REPAIR_COSTING_URI = '/repairCosting';

export const createNewRepairCosting = async (
  repairCosting: TRepairCostingSchema,
) => {
  return requestApi({
    url: REPAIR_COSTING_URI,
    method: HTTP_METHOD.POST,
    body: repairCosting,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingRepairCosting = async (
  query?: TRepairCostingSchema,
) => {
  let url = `${REPAIR_COSTING_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.equipmentId) {
    params.append('equipmentId', query.equipmentId);
  }

  if (query?.damageId) {
    params.append('damageId', query.damageId);
  }

  if (query?.repairServiceId) {
    params.append('repairServiceId', query.repairServiceId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllRepairCostings = async () => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/allRepairCostings`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const allRepairServicesByEquipmentDamage = async (
  query?: FindAllRepairServicesByEquipmentDamage,
) => {
  let url = `${REPAIR_COSTING_URI}/allRepairServicesByEquipmentDamage`;
  const params = new URLSearchParams();

  if (query?.equipmentId) {
    params.append('equipmentId', query.equipmentId);
  }

  if (query?.equipmentClassId) {
    params.append('equipmentClassId', query.equipmentClassId.toString());
  }

  if (query?.damageId) {
    params.append('damageId', query.damageId);
  }

  if (query?.damageClassId) {
    params.append('damageClassId', query.damageClassId.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllRepairCostings = async (
  filter: EquipmentDmgFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const filterMapped = mapDmgFilterAPI(filter);

  let url = `${REPAIR_COSTING_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getRepairCostingById = async (id: string) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateRepairCosting = async (
  repairCosting: TRepairCostingSchema,
) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: repairCosting,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyRepairCostings = async (
  repairCostings: TRepairCostingSchema[],
) => {
  return requestApi({
    url: `${REPAIR_COSTING_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: repairCostings,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
